import { cva } from "class-variance-authority";
import { Button } from "../../../button";
import { Icon } from "../../../icons";
import { useDataTableContext } from "../context";

/** Props Interface */
interface SortingIndicatorProps {
	columnId: string;
	onClick: () => void;
}

export function SortingIndicator({ columnId, onClick }: SortingIndicatorProps) {
	/** Context */
	const { table, sorting: _sorting } = useDataTableContext();

	if (!table) return null;

	/** Computed */
	const sortByDirection = table.getColumn(columnId)?.getIsSorted() ?? false;
	const iconClasses = icon({ sortByDirection: sortByDirection });

	/** Render */
	return (
		<Button
			size="xxs"
			variant="ghost"
			icon={
				<div className="flex flex-row items-center translate-y-[1px]">
					<Icon
						name="ArrowUpDown"
						className={iconClasses}
					/>
				</div>
			}
			onClick={onClick}
		/>
	);
}

const icon = cva(["[&_path]:opacity-20"], {
	variants: {
		sortByDirection: {
			asc: ["[&_path:nth-child(3)]:opacity-100", "[&_path:nth-child(4)]:opacity-100"],
			desc: ["[&_path:nth-child(1)]:opacity-100", "[&_path:nth-child(2)]:opacity-100"],
			false: [],
		},
	},
});
